import React from "react";

const LogView = () => (
  <>
  <p>You are logged</p>
  </>
);
export default LogView;
